import styled from 'styled-components';

interface IContentProps {
  isRow?: boolean;
}

export const Container = styled.div`
  min-width: 30%;
  border-left: 1px solid ${({ theme }) => theme.colors.gray};

  .findCorrespondents {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;

    button {
      text-transform: none;
      border-radius: 1rem;
      border: 1px solid ${({ theme }) => theme.colors.tertiary_500};
      padding: 0 0.5rem;
      color: ${({ theme }) => theme.colors.tertiary_500};
    }
  }

  @media (max-width: 690px) {
    width: -webkit-fill-available;
    border-left: none;
  }
`;
export const Content = styled.div<IContentProps>`
  display: flex;
  flex-direction: column;
  padding-left: 0.9rem;
  gap: 0.5rem;

  span {
    display: flex;
    font-size: 1.2rem;
    color: ${({ theme }) => theme.colors.text_gray};
    font-weight: 400;
    padding: 0 0.5rem;
  }

  h1 {
    color: ${({ theme }) => theme.colors.secondary};
    font-size: 1.2rem;
    font-weight: 500;
  }
  .MuiPaper-root {
    box-shadow: none;
  }
  .contentAdditionalValue {
    p {
      font-size: 1.2rem;
      color: ${({ theme }) => theme.colors.primary};
      font-weight: 400;
      padding: 0 0.5rem;
    }
  }

  .containerCorrespondent {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-bottom: 1rem;
    h1 {
      color: ${({ theme }) => theme.colors.secondary};
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .containerCorrespondences {
    max-height: 25rem;
    overflow-y: auto;
  }

  .contentCorrespondences {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    overflow: auto;
    padding: 1rem;
  }

  .solicitationPaymentAccounts {
    display: flex;
    flex-direction: column;

    h1 {
      display: flex;
      gap: 0.5rem;
      align-items: center;
      font-size: 1.4rem;
      font-weight: 400;
      margin: 0.5rem 0;

      svg {
        width: 1.1rem;
        height: 1.5rem;
        fill: ${({ theme }) => theme.colors.secondary};
      }
    }

    button {
      border-radius: 1rem;
      text-transform: none;
    }

    .unPaid {
      display: flex;
      color: ${({ theme }) => theme.colors.error};
      align-items: center;
      gap: 0.5rem;

      svg {
        width: 1rem;
        height: 1rem;
        stroke: ${({ theme }) => theme.colors.error};
      }
    }

    .paidOut {
      display: flex;
      align-items: center;
      font-size: 1.1rem;
      gap: 0.5rem;
      color: ${({ theme }) => theme.colors.primary};
    }

    .paymentAccountsContent {
      display: flex;
      flex-direction: column;
      gap: 1rem;

      .button-card-pix {
        width: 100%;
        margin-bottom: 0.5rem;
        padding: 15px 8px 0px 8px;
        box-shadow: 1px 2px 6px rgba(0, 0, 0, 0.2);
        background-color: ${({ theme }) => theme.colors.background_white};
        border-radius: 1rem;

        .cnt-card-pix {
          width: 100%;
          height: auto;
          border-radius: 8px;
          opacity: 1;
          padding: 5px;

          img {
            height: 3rem;
          }
        }
      }
    }

    .containerSeeMore {
      display: flex;
      justify-content: flex-end;
      margin: 0.5rem;

      button {
        text-transform: none;
        font-size: 1.1rem;
        border-radius: 0.5rem;
        color: ${({ theme }) => theme.colors.tertiary_500};
        font-weight: 400;
      }
    }
  }

  .canceled {
    padding-top: 1rem;
    h1 {
      font-size: 1.5rem;
      color: ${({ theme }) => theme.colors.secondary};
      font-weight: 700;
    }

    span {
      font-size: 1.2rem;
      color: ${({ theme }) => theme.colors.text_gray};
    }
  }

  @media (max-width: 690px) {
    padding-left: 0;
    ${({ isRow, theme }) =>
      isRow &&
      `
      flex-direction: row;
      justify-content: space-between;

      .contentAdditionalValue{
        min-width: 40%;
      }

      .solicitationPaymentAccounts{
        min-width: 40%;

        h1{
          margin: 0;
          padding: 0;
          color: ${theme.colors.secondary};
          font-size: 1.2rem;
          font-weight: 500;
        }
      }
    `};
  }

  @media (max-width: 390px) {
    flex-direction: column;

    .solicitationPaymentAccounts div {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;

      button {
        justify-content: left;
      }

      .containerSeeMore {
        align-self: end;
      }
    }
  }
`;

export const ContentModal = styled.div``;

export const HeaderModal = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 2rem;

  h1 {
    display: flex;
    align-items: center;
    font-size: 1.5rem;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.secondary};

    svg {
      fill: ${({ theme }) => theme.colors.secondary};
      width: 1.75rem;
      height: 1.75rem;
      margin-right: 0.5rem;
    }
  }

  .close-div {
    padding: 0;
    height: 20px;

    button {
      color: #fff;
      background-color: ${({ theme }) => theme.colors.tertiary_500};
      width: 20px;
      height: 19px;
      border-radius: 100%;
      padding: 0;
      border: none;

      :hover {
        cursor: pointer;
      }
    }
  }
`;
